export default __webpack_public_path__ + "602b2f83acc121e74477737d4bff8865.png";